import { render, staticRenderFns } from "./AudioBookIndex.vue?vue&type=template&id=63c873b8&"
import script from "./AudioBookIndex.vue?vue&type=script&lang=js&"
export * from "./AudioBookIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports